import { IController, IWindowService } from 'angular';
import { IStateService } from 'angular-ui-router';
import * as _ from 'lodash';

import { GraduationPlan } from './../../../../../../../ng2/shared/constants/graduation-plan.constant';
import { WizardUtils } from './../../../../../../shared/services/wizard-utils/wizard-utils.service';

export class GradPlansCtrl implements IController {
  static $inject: string[] = ['$scope', 'WizardUtils', '$state', '$window'];

  public filteredStudents;
  public studentsWithoutGradPlanOrDate;
  public options;

  constructor(
    public $scope,
    private WizardUtils: WizardUtils,
    private $state: IStateService,
    private $window: IWindowService,
  ) {}

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi(): void {
    this.filteredStudents = this.WizardUtils.getFilteredFlattenedStudents();
    this.studentsWithoutGradPlanOrDate = this.getStudentsWithNoGradPlanOrDate();
    this.options = {
      columnKeys: ['cohort', 'gradPlan', 'plannedDiplomaType', 'plannedGraduationDate'],
    };
  }

  goToGradPlanningWizard() {
    const url = this.$state.href(`main.school.new-sdc.grad-planning.wizard`);
    this.$window.open(url, '_blank');
  }

  getStudentsWithNoGradPlanOrDate(): string[] {
    return _.reduce(
      this.filteredStudents,
      (studentIdCollection: string[], student: any) => {
        const { gradPlan, studentId } = student;
        if (
          !gradPlan ||
          gradPlan === GraduationPlan.PLAN_INCOMPLETE.humanName ||
          gradPlan === GraduationPlan.PLAN_IN_PAST.humanName
        )
          studentIdCollection.push(studentId);
        return studentIdCollection;
      },
      [],
    );
  }
}
